/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_CharsInputs */



/**
* | output |
* | --- |
* | "Show Character Count Per Line" |
*
* @param {Options_Metrics_Show_CharsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_chars = /** @type {((inputs?: Options_Metrics_Show_CharsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_CharsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "de") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "it") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "es") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Show Character Count Per Line")
	return /** @type {LocalizedString} */ ("Show Character Count Per Line")
});